import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Plus } from "lucide-react";

const url = "https://tec.utpl.edu.ec";

const OfferTec = () => {
  const [carreras, setCarreras] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://tec.utpl.edu.ec/tec-periodo-1")
      .then((res) => res.json())
      .then((data) => {
        setCarreras(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  }, []);

  const IsPeriodo = (data) => {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p className="text-sm text-gray-600 leading-none p-0">
          <strong>Periodo:</strong> {data}
        </p>
      );
    }
    return null;
  };

  if (loading) {
    return <p className="text-center py-10">Cargando...</p>;
  }

  return (
    <div className="px-16 md:px-10">
      {/* Contador */}
      <div className="mb-6">
        <p className="text-gray-700">
          Mostrando{" "}
          <span className="font-bold text-gray-900">
            <AnimatePresence mode="wait">
              <motion.span
                key={carreras.length}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.2 }}
              >
                {carreras.length}
              </motion.span>
            </AnimatePresence>
          </span>{" "}
          programas
        </p>
      </div>

      {/* Grid */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {carreras.map((carrera, index) => (
          <motion.a
            key={index}
            href={carrera.field_enlace_contenido}
            target="_blank"
            rel="noreferrer"
            className="group relative block bg-white rounded-2xl shadow-md overflow-hidden"
            initial="rest"
            animate="rest"
            whileHover="hover"
            whileTap="tap"
          >
            {/* Imagen */}
            <div className="h-40 overflow-hidden">
              <img
                src={url + carrera.field_imagen_template}
                alt={carrera.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            </div>

            {/* Botón + */}
            <motion.div
              variants={{
                rest: { scale: 1, opacity: 0.8 },
                hover: { scale: 1.2, opacity: 1 },
              }}
              className="absolute top-4 right-4 bg-white/90 backdrop-blur-md rounded-full p-2 shadow-md"
            >
              <Plus size={12} />
            </motion.div>

            {/* Contenido */}
            <div className="p-5 space-y-3">
              <h3 className="text-lg font-bold leading-tight">
                {carrera.title}
              </h3>

              {carrera.field_modalidad && (
                <p className="text-sm text-gray-600 leading-none p-0">
                  <strong>Modalidad:</strong> {carrera.field_modalidad}
                </p>
              )}

              {carrera.field_duracion && (
                <p className="text-sm text-gray-600 leading-none p-0">
                  <strong>Duración:</strong> {carrera.field_duracion}
                </p>
              )}

              {IsPeriodo(carrera.field_periodo)}

              
            </div>

            {/* Overlay */}
            <motion.div
              variants={{
                rest: { opacity: 0 },
                hover: { opacity: 1 },
                tap: { opacity: 1 },
              }}
              className="absolute inset-0 bg-black/10 flex items-center justify-center"
            >
              <ArrowRight size={44} className="text-white" />
            </motion.div>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default OfferTec;